var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-time-select',{ref:_vm.field.name,staticClass:"timepicker",class:{
    big: _vm.size === 'big',
    medium: _vm.size === 'medium',
    small: _vm.size === 'small',
    'is-error': !!_vm.field.error,
    'no-label': !!_vm.$attrs['no-label']
  },attrs:{"name":_vm.field.name,"size":_vm.size,"placeholder":_vm.field.placeholder || '',"readonly":_vm.field.readonly,"format":_vm.format,"clearable":false,"value-format":_vm.format,"disabled":_vm.disabled(_vm.field) || _vm.field.disabled,"picker-options":_vm.options},on:{"change":_vm.handleChange},nativeOn:{"input":function($event){return _vm.handleInput.apply(null, arguments)}},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }